import React from "react";
import { DeviceMobile, BellSimple, Lightning, Calendar } from "@phosphor-icons/react";
import ComingSoonShell from "@/components/ComingSoonShell";

export default function AppMobileComingSoon() {
  return (
    <ComingSoonShell
      testid="coming-soon-mobile"
      title={<>App mobile <span className="font-editorial italic">native.</span></>}
      intro="Pronto sul tuo telefono come un'app vera, con notifiche push, accesso veloce al sopralluogo, microfono sempre a portata di mano."
      preview={(
        <div className="flex items-center gap-4">
          <div className="shrink-0 w-20 h-32 sm:w-24 sm:h-40 rounded-[14px] border-[3px] border-[#1C1C1A] bg-[#F1F4ED] flex items-center justify-center relative overflow-hidden">
            <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-8 h-1 bg-[#1C1C1A] rounded-full" />
            <div className="text-center px-2">
              <DeviceMobile size={22} weight="duotone" className="text-[#7C8B6E] mx-auto" />
              <div className="font-editorial text-[14px] text-[#7C8B6E] mt-1">Pronto</div>
            </div>
          </div>
          <div className="flex-1 min-w-0 text-[13px] text-[#3A3A36] leading-relaxed">
            <div className="font-semibold text-[#1C1C1A] mb-1">iPhone · Android</div>
            Apri l'app dalla home, registra una nota in 2 secondi, ricevi
            notifiche degli appuntamenti — senza dover aprire il browser.
          </div>
        </div>
      )}
      whyNotYet="Stiamo costruendo Pronto bene sul web prima di portarlo su iPhone e Android. Le app native richiedono test rigorosi — preferiamo aspettare di avere tutte le feature stabili che essere su tutti gli store. Intanto, su mobile, Pronto funziona già benissimo dal browser e si può installare come PWA dalla home."
      whatItWillDo={[
        { icon: BellSimple, label: "Notifiche push native", body: "Promemoria appuntamenti, nuove richieste, contatti che rispondono — senza dover tenere il browser aperto." },
        { icon: Lightning, label: "Microfono sempre pronto", body: "Apri l'app, premi e parla. Niente attesa, niente permessi browser ogni volta." },
        { icon: Calendar, label: "Sync agenda nativa", body: "Appuntamenti Pronto direttamente nel calendario di iPhone o Android, integrati con Siri / Google Assistant." },
      ]}
      interestSlug="app-mobile"
      interestTitle="App mobile native (iOS + Android)"
    />
  );
}
